import React, { useState } from 'react';
import classes from './SearchButton.module.css';

import { useDispatch, useSelector } from 'react-redux';
import { bookingActions } from '../../store/booking-slice';
import Button from '../UI/Button';

const SearchButton = () => {
  const dispatch = useDispatch();

  const checkInDate = useSelector((state) => state.booking.checkInDate);
  const checkOutDate = useSelector((state) => state.booking.checkOutDate);

  const [formValid, setFormValid] = useState(true);

  const checkRatesClickHandler = () => {
    const isValid = Boolean(checkInDate && checkOutDate);
    setFormValid(isValid);

    if (isValid) {
      dispatch(bookingActions.toggleDatesConfirmed());
    }
  };

  return (
    <>
      <Button onClick={checkRatesClickHandler} buttonText="Check Rates" />
      {!formValid && (
        <p className={classes.errorMessage}>Please enter your travel dates!</p>
      )}
    </>
  );
};

export default SearchButton;
